export default __webpack_public_path__ + "static/media/carousel1.c0292277.png";